/*=========================================================================================
  File Name: module-resource-actions.js
  Description: Resource Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import ResourceAPI from '@/api/ResourceAPI.js';
import httpClient from '../../api/axios-httpclient';
import commonFunc from '@/common/commonFunction';
import { MSEnum } from '../../common/enumeration';

export default {
	/**
	 * Lấy danh sách lịch sử cấp tài nguyên
	 */
	loadResources: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url:
					ResourceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) +
					`/${localStorage.getItem('SubscriberCode')}`,
				params: payload
			},
			true
		);
		if (res && res.Success) {
			context.commit('updateResources', res);
		}
	},

	/**
	 * Lấy danh sách đơn hàng
	 */
	loadOrders: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url:
					ResourceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) +
					'/order' +
					`/${localStorage.getItem('SubscriberCode')}`,
				params: payload
			},
			true,
			false
		);
		if (res && res.Success) {
			context.commit('updateOrders', res);
			if (res.Data.length > 0) {
				let unpaids = res.Data.filter(x => x.PaymentStatus == MSEnum.PaymentStatus.New);
				context.commit('updateUnpaidOrders', unpaids);
			}
		}
	},

	/**
	 * Lấy đường dẫn vào misa store để mua thêm, gia hạn
	 */
	getLinkStore: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: ResourceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/linkstore`,
				params: payload
			},
			true
		);
		if (res && res.Success) {
			return res.Data;
		}
	},
	/**
	 * Hủy đơn hàng
	 */
	cancelOrder: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ResourceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/cancelorder`,
				params: payload
			},
			true
		);
		return res;
	},

	/**
	 * Xác nhận thanh toán
	 */
	confirmPayment: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: ResourceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/confirmpayment`,
				params: payload
			},
			true
		);
		return res;
	},

	/**
	 * Lấy đơn hàng chưa thanh toán để cảnh báo người dùng
	 */
	loadUnpaidOrders: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url:
					ResourceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) +
					'/unpaidorders' +
					`/${localStorage.getItem('SubscriberCode')}`,
				params: payload
			},
			true,
			false
		);
		if (res && res.Success) {
			context.commit('updateUnpaidOrders', res.Data);
		}
	}
};
